import React, { useEffect, useState } from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/LoginPage.css';

const LoginPage: React.FC = () => {
  const { login, error, isAuthenticated, isUnauthorized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loginAttempted, setLoginAttempted] = useState(false);
  
  // Get the page the user was trying to access, or default to home
  const from = (location.state as any)?.from || '/';
  
  // Redirect if already authenticated (and not unauthorized)
  useEffect(() => {
    if (isAuthenticated && !isUnauthorized) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, isUnauthorized, navigate, from]);

  const handleGoogleSuccess = async (credentialResponse: any) => {
    if (credentialResponse.credential) {
      setLoginAttempted(true);
      await login(credentialResponse.credential);
    }
  };

  // After login attempt, if successful (no error and authenticated), redirect
  useEffect(() => {
    if (loginAttempted && isAuthenticated && !error) {
      navigate(from, { replace: true });
    }
  }, [loginAttempted, isAuthenticated, error, navigate, from]);

  const handleGoogleError = () => {
    // Google login failed
  };

  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

  if (!googleClientId) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h1>Configuration Error</h1>
          <p>Google Client ID is not configured. Please set REACT_APP_GOOGLE_CLIENT_ID in your .env file.</p>
        </div>
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>Quick Refer App</h1>
            <p>Sign in with your company account</p>
          </div>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <div className="login-button-container">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap
              theme="outline"
              size="large"
              text="signin_with"
              shape="rectangular"
            />
          </div>
          
          <div className="login-footer">
            {process.env.REACT_APP_ALLOWED_COMPANY_DOMAIN ? (
              <p>Only @{process.env.REACT_APP_ALLOWED_COMPANY_DOMAIN} email addresses are allowed</p>
            ) : (
              <p>All email addresses are allowed (development mode)</p>
            )}
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default LoginPage;